import { render, staticRenderFns } from "./Profit.vue?vue&type=template&id=9b8ad214"
import script from "./Profit.vue?vue&type=script&lang=js"
export * from "./Profit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports